import { render, staticRenderFns } from "./ReratedCoursesC.vue?vue&type=template&id=4d13b382&"
import script from "./ReratedCoursesC.vue?vue&type=script&lang=js&"
export * from "./ReratedCoursesC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports